<template>
  <div v-if="project">
    <action-bar></action-bar>
    <main class="content">
      <h1>
        Projekt bearbeiten
        <br>
        <small class="text-muted">{{project.name.text}}</small>
      </h1>
      <a
        :href="portalBaseUrl + '/' + store.state.language + '/projects/' + project.id"
        target="_blank"
      >
        <i class="fal fa-share"></i> Liveansicht
      </a> &nbsp;
      <a
        :href="portalBaseUrl + '/' + store.state.language + '/projects/preview/' + project.id"
        target="_blank"
      >
        <i class="fal fa-share"></i> Vorschau aller Blöcke
      </a>
      <br>
      <br>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'project-edit', params: {projectId: $route.params.projectId}}"
            exact
          >Generelle Texte</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'project-edit-micropage', params: {projectId: $route.params.projectId}}"
          >Micropage</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'project-edit-results', params: {projectId: $route.params.projectId}}"
          >Resultate</router-link>
        </li>
      </ul>
      <div class="tab-content">
        <router-view class="tab-pane fade show active" :data="project" entity="project"/>
      </div>
    </main>
  </div>
  <loading v-else></loading>
</template>
<script>
import moment from 'moment';

export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    portalBaseUrl: function() {
      return portalBaseUrl;
    },
    store: function() {
      return store;
    }
  },
  asyncComputed: {
    project() {
      let promises = [];
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/project/" +
            this.$route.params.projectId
        )
      );
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/project/" +
            this.$route.params.projectId +
            "/results"
        )
      );
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/project/" +
            this.$route.params.projectId +
            "/blocks"
        )
      );

      return Promise.all(promises).then(responses => {
        let project = responses[0].data.result;
        project.results = responses[1].data.result;
        project.blocks = responses[2].data.result;

        if (project.disclaimerDate)
          project.disclaimerDate = moment(project.disclaimerDate.date);

        return project;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/project/Edit.vue